import { useMemo } from 'react';
import { collectDescendantNodeIds } from 'state/product-description/helper';
import type { ProductNode } from 'state/product-description/model';

import { useCountPatchedFields } from './useCountPatchedFields';

type BlocksNodes = ReadonlyArray<ProductNode | undefined>;

export function useDirectChildrenBlocksPatchedFields(blocksNodes: BlocksNodes): number[] {
  const blocksFieldIds = useMemo(() => blocksNodes.map(node => collectDescendantNodeIds(node)), [blocksNodes]);
  return useCountPatchedFields(blocksFieldIds);
}
